/**
 * Inline MSW responses for carrier-portal admin endpoints. The login URL is
 * computed server-side from a signing key (no exported fixture), so a
 * representative value lets the Generate-login-URL dialog render in mock mode
 * and snapshots; the live backend signs the real link.
 */
export const CARRIER_PORTAL_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  "/apollo/carriers/generate-login-url": {
    url: "https://carriers.freightsimple.com/?token=v1%7Clink%7Csaia%7Cm9Xexampletokensignature",
  },
  // The access trail. Two people, one of them a repeat visitor, so the tab's
  // story shows both activity kinds and a section view.
  "/apollo/carriers/portal-activity": [
    {
      carrierPortalActivityId: "aaaaaaaa-0000-0000-0000-000000000001",
      carrierIdentifier: "estes",
      activityType: "page_view",
      personName: "Dana Whitfield",
      personEmail: "dana@estes-express.example",
      detail: "invoiceAudits",
      createdAt: "2026-03-05T16:42:00Z",
    },
    {
      carrierPortalActivityId: "aaaaaaaa-0000-0000-0000-000000000002",
      carrierIdentifier: "estes",
      activityType: "session_resumed",
      personName: "Dana Whitfield",
      personEmail: "dana@estes-express.example",
      createdAt: "2026-03-05T16:41:00Z",
    },
    {
      carrierPortalActivityId: "aaaaaaaa-0000-0000-0000-000000000003",
      carrierIdentifier: "estes",
      activityType: "sign_in",
      personName: "Sam Okafor",
      personEmail: "sam@estes-express.example",
      createdAt: "2026-02-19T14:05:00Z",
    },
  ],
};
